import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../helpers/grids/helpers";

function initProductionsIndex() {
	createGrid('.productions-grid', {
			columnDefs: [
				{
					field: "name",
					headerName: 'Name',
					sortable: true,
				},
				{
					field: "start_date",
					headerName: 'Start Date',
					sortable: true,
					sort: "desc",
				},
				{
					field: "created_at",
					headerName: 'Created',
					width: 200,
					sortable: true,
				},
				{
					field: "public_id",
					headerName: '',
					maxWidth: 280,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const buttons = createElement(`
                            <div class="buttons">
                            	<a class="btn btn-primary btn-sm ${!params.data.can_view ? 'd-none' : ''} " href="${params.data.view_url}">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    View
								</a>
                                <a class="btn btn-primary btn-sm ${!params.data.can_edit ? 'd-none' : ''}" href="${params.data.edit_url}">
                                    <i class="fa-solid fa-user-pen"></i>
                                    Edit
								</a>
                                <button type="button" class="btn btn-danger btn-sm remove-production-button ${!params.data.can_delete ? 'd-none' : ''}">
                                    <i class="fa-solid fa-trash"></i>
                                    Remove
                                </button>
                            </div>`
						)

						const deleteButton = buttons.querySelector('.remove-production-button');

						deleteButton.onclick =
							() => removeProduction(params.data);

						// Remove delete button from admin
						if (params.data.id === 1) {
							deleteButton.remove();
						}

						return buttons;
					})
				},
			],
			paginationPageSize: 20,
			_rowName: 'Productions',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				loading();
				// noinspection JSUnresolvedVariable
				window.location.href = data.view_url;
			}),
		},
		window['routes/admin.productions.grid'],
	);

	/** Methods */

	function removeProduction(production) {
		swalConfirm({
			title: 'Are you sure you want to delete this production?'
		}).then(response => {
			if (response.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(production.remove_url)
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading);
			}
		})

	}
}

export {
	initProductionsIndex
}
